import Tools from './tools.controller';

export default Tools;
